<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">ALFRED RAWORTH’S</h1>
<p class="titlea">ELECTRIC SOUTHERN RAILWAY</p>
<p class="author">PETER STEER</p>
<div class="image_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?56b873c0